import { IChiaPhongTheoSoPhongRequest } from "../../model/request/tct/IChiaPhongTheoSoPhongRequest";
import { IChiaSinhVienVaoPhongRequest } from "../../model/request/tct/IChiaSinhVienVaoPhongRequest";
import { IPhongThiChiaThuCongRequest } from "../../model/request/tct/IPhongThiChiaThuCongRequest";
import { IDuKienMoPhong } from "../../model/respone/tct/IDuKienMoPhong";
import { IPhongThi } from "../../model/respone/tct/IPhongThi";
import { apiClient } from "../apiClient";
import { IIdsRequest } from './../../model/request/IIdsRequest';
import { DOT_THI_API } from "./dotThiApi";

export const PHONG_THI_API = "phong-thi";
export const phongThiApi = {
  SelectAll: () => apiClient.get(`${PHONG_THI_API}`),
  SelectByDot: (dotThiId: number) => apiClient.get(`${DOT_THI_API}/${dotThiId}/phong-thi`),
  SelectHtmlPrintDanhSach: (phongThiId: number) => apiClient.get(`${PHONG_THI_API}/${phongThiId}/html`),
  SelectHtmlPrintDanhSachPhong: (request: IIdsRequest) => apiClient.put(`${PHONG_THI_API}/html-phong`, request),
  Insert: (payload: IPhongThi) => apiClient.post(`${PHONG_THI_API}`, payload),
  Update: (payload: IPhongThi) => apiClient.put(`${PHONG_THI_API}`, payload),
  Updates: (payload: IPhongThi[]) => apiClient.put(`${PHONG_THI_API}/updates`, payload),
  Delete: (id: number) => apiClient.delete(`${PHONG_THI_API}/${id}`),
  Deletes: (request: IIdsRequest) => apiClient.post(`${PHONG_THI_API}/deletes`, request),
  ChiaThuCong: (request: IPhongThiChiaThuCongRequest) => apiClient.post(`${PHONG_THI_API}/chia-thu-cong`, request),
  ReadAndValidateImportData: (payload: any) => apiClient.post(`phong-thi/import/read-and-validate`, payload),
  Import: (payload: any) => apiClient.post(`phong-thi/import`, payload),
  DuKienMoPhong: (id_dot_thi: number) => apiClient.get(`${PHONG_THI_API}/du-kien-mo-phong/${id_dot_thi}`),
  UpdateDuKienMoPhong: (request: IDuKienMoPhong[]) => apiClient.put(`${PHONG_THI_API}/du-kien-mo-phong/updates`, request),
  ChiaPhongTheoSoLuongPhong: (request: IChiaPhongTheoSoPhongRequest) => apiClient.post(`${PHONG_THI_API}/chia-phong-du-kien`, request),
  ChiaSinhVienVaoPhong: (request: IChiaSinhVienVaoPhongRequest) => apiClient.post(`${PHONG_THI_API}/chia-sinh-vien-vao-phong`, request),
};
